import { Injectable } from '@angular/core';
import packageInfo from '../../../package.json'; // Asegúrate de la ruta correcta

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  getVersion(): string {
    return packageInfo.version;
  }
}
